import Swiper from 'swiper';
import { Navigation, A11y, Keyboard } from 'swiper/modules';

export default function initImageCarousel() {
  const blocks = document.querySelectorAll('.aviatrix-block--image-carousel');

  blocks.forEach(block => {
    const gallery  = block.querySelector('.image-carousel__gallery');
    const template = block.querySelector('.image-carousel__controls-template');
    if (!gallery) return;

    const images = Array.from(gallery.querySelectorAll(':scope > .wp-block-image'));
    if (images.length < 2) return;

    const MIN_SLIDES = 6;
    const slideSources = images.slice();
    while (slideSources.length < MIN_SLIDES) {
      images.forEach(image => {
        const clone = image.cloneNode(true);
        clone.querySelectorAll('.lightbox-trigger, .gallery-image-download').forEach(el => el.remove());
        slideSources.push(clone);
      });
    }

    const heading = block.querySelector('.image-carousel__heading');
    const label   = heading && heading.textContent.trim() ? heading.textContent.trim() : 'Image carousel';

    const viewport = document.createElement('div');
    viewport.className = 'image-carousel__viewport';
    viewport.setAttribute('role', 'group');
    viewport.setAttribute('aria-roledescription', 'carousel');
    viewport.setAttribute('aria-label', label);
    gallery.parentNode.insertBefore(viewport, gallery);
    viewport.appendChild(gallery);

    const track = document.createElement('div');
    track.className = 'image-carousel__track';
    slideSources.forEach(node => {
      const slide = document.createElement('div');
      slide.className = 'image-carousel__slide';
      slide.appendChild(node);
      track.appendChild(slide);
    });
    gallery.appendChild(track);

    if (block.dataset.imageCarousel && !gallery.id) {
      gallery.id = block.dataset.imageCarousel;
    }

    let prevEl = null;
    let nextEl = null;
    if (template && template.content) {
      const controls = template.content.firstElementChild.cloneNode(true);
      viewport.appendChild(controls);
      prevEl = controls.querySelector('.image-carousel__nav--prev');
      nextEl = controls.querySelector('.image-carousel__nav--next');
    }

    new Swiper(gallery, {
      modules: [Navigation, A11y, Keyboard],
      wrapperClass: 'image-carousel__track',
      slideClass: 'image-carousel__slide',
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 24,
      loop: true,
      watchSlidesProgress: true,
      keyboard: { enabled: true, onlyInViewport: true },
      a11y: {
        prevSlideMessage: 'Previous image',
        nextSlideMessage: 'Next image',
        firstSlideMessage: 'This is the first image',
        lastSlideMessage: 'This is the last image',
      },
      navigation: {
        prevEl,
        nextEl,
        disabledClass: 'swiper-button-disabled',
      },
    });
  });
}
